var map = {
	"./1AGP.png": 14393,
	"./2AGР.png": 41210,
	"./3AGP.png": 56216,
	"components/Catalog/AGP/img/glass/pr/prPlusGrayNight/1AGP.png": 14393,
	"components/Catalog/AGP/img/glass/pr/prPlusGrayNight/2AGР.png": 41210,
	"components/Catalog/AGP/img/glass/pr/prPlusGrayNight/3AGP.png": 56216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58507;